<script>
export default {
  functional: true,
  name: 'InnerSlider',
  render: function (h, { props, parent, children, listeners, ...args }) {
    const { name, value, min, max, type, range = false, showLabel } = props
    const change = listeners.change
    const changeFunc = value => {
      change(value)
      //针对于el-slider
      const ref = 'elSlider'
      if (parent.$refs[ref]) {
        setTimeout(() => {
          parent.$refs[ref] && parent.$refs[ref].$refs['button1'] && parent.$refs[ref].$refs['button1'].handleMouseLeave()
        }, 500)
      }
    }
    return (
      <div class={'sliderInput'}>
        {name && showLabel && <span class="scence_ctr_span_title">{name}</span>}
        <div class={'scence_ctr_div_slider'}>
          <div class={'sevice_slider_new'}>
            <el-slider min={min} max={max} value={value} onInput={changeFunc} range={range} ref="elSlider" />
          </div>
          <el-input-number class="input_number_action" min={min} max={max} onChange={change} value={value} style="width: 60px;" />
          <span class="lightUnit"  style={`margin-left: 4px; visibility: ${type != null && type.indexOf('0x03') != -1 ?'visible':'hidden'};`}>
              {'%'}
            </span>
        </div>
      </div>
    )
  },
}
</script>

<style lang="scss" scoped>
@import '~@/components/button/comps-button.scss';
.scence_ctr_div_slider {
  flex: 1;
}
.sevice_slider_new{
  flex:1;
  
}
</style>
